// ============================================================================
// Table Columns: PauseReasons
// Key: pauseReasons
// Generated file. Do not edit manually.
// ============================================================================

// #region Imports
import {
	cellRenderer,
	type EntityTableConfig,
	relationCountRenderer,
} from '../../entity-config-runtime/entity-table-config'
import type {
	PauseReasonDto,
	PauseReasonSummary,
	TeamPauseReasonResponse,
	TeamSummary,
	UserDto,
	UserPauseReasonDto,
} from '../api/backstage.schemas'
// #endregion

// #region Entity List Columns
export const pauseReasonsListColumnsConfig = {
	columns: [
		'name',
		cellRenderer('color', 'color'),
		cellRenderer('sortOrder', 'number'),
		relationCountRenderer('userCount', 'users'),
		relationCountRenderer('teamCount', 'teams'),
		'modifiedBy',
		cellRenderer('modifiedUtc', 'dateTime'),
	],
	actions: [
		{
			type: 'link',
			id: 'id',
			label: 'tables_actions_detail',
			icon: 'ArrowRight',
			style: 'link',
			href: (row: PauseReasonSummary) => `/pauseReasons/${row.id}/details`,
		},
	],
} as const satisfies EntityTableConfig<PauseReasonSummary>
// #endregion

// #region Relation List Columns
// #region Relation: Teams
export const pauseReasonsRelationsTeamsAssignedColumnsConfig = {
	columns: [
		'teamName',
		'pauseReasonName',
		cellRenderer('pauseReasonColor', 'color'),
	],
} as const satisfies EntityTableConfig<TeamPauseReasonResponse>
export const pauseReasonsRelationsTeamsAvailableColumnsConfig = {
	columns: [
		'modifiedBy',
		cellRenderer('modifiedUtc', 'dateTime'),
		'name',
		cellRenderer('isDefaultTeam', 'boolean'),
		'userGroup',
		'responsibleUserGroup',
		cellRenderer('userCount', 'number'),
		cellRenderer('queueCount', 'number'),
		cellRenderer('skillCount', 'number'),
		cellRenderer('customPageCount', 'number'),
		cellRenderer('skillGroupCount', 'number'),
	],
} as const satisfies EntityTableConfig<TeamSummary>
// #endregion

// #region Relation: Users
export const pauseReasonsRelationsUsersAssignedColumnsConfig = {
	columns: [
		'pauseReasonName',
		cellRenderer('pauseReasonColor', 'color'),
		'userFirstName',
		'userLastName',
		'userEmail',
		'userLogonName',
	],
} as const satisfies EntityTableConfig<UserPauseReasonDto>
export const pauseReasonsRelationsUsersAvailableColumnsConfig = {
	columns: [
		'firstName',
		'lastName',
		'email',
		cellRenderer('isDisabled', 'boolean'),
		'logonName',
		'extension',
		'customProperty1',
		'customProperty2',
		'customProperty3',
		'customProperty4',
		'customProperty5',
	],
} as const satisfies EntityTableConfig<UserDto>
// #endregion
// #endregion

// #region Client List Columns
export const pauseReasonsClientGetColumnsConfig = {
	columns: ['name', cellRenderer('color', 'color')],
} as const satisfies EntityTableConfig<PauseReasonDto>
// #endregion

// #region Columns Config Export
export const pauseReasonsColumnsConfig = {
	list: pauseReasonsListColumnsConfig,
	relations: {
		teams: {
			assigned: pauseReasonsRelationsTeamsAssignedColumnsConfig,
			available: pauseReasonsRelationsTeamsAvailableColumnsConfig,
		},
		users: {
			assigned: pauseReasonsRelationsUsersAssignedColumnsConfig,
			available: pauseReasonsRelationsUsersAvailableColumnsConfig,
		},
	},
	client: {
		get: pauseReasonsClientGetColumnsConfig,
	},
} as const
// #endregion
